import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-jquiauto-complete',
	templateUrl:'./JQUIAutoCompletePage.html',
	styles: [],
	styleUrls:['./JQUIAutoCompletePage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class JQUIAutoCompletePage
{
	mdContent_181 = `\`\`\`java
import com.jwebmp.plugins.jqueryui.autocomplete.JQUIAutoComplete;
\`\`\``;
	mdContent_182 = `\`\`\`java
new JQUIAutoComplete&lt;&gt;()
\`\`\``;
	mdContent_183 = `\`\`\`java
var auto = new JQUIAutoComplete<>();
auto.getOptions().setSource(List.of("Java", "JavaScript", "Python"));
\`\`\``;
}
